import { WarningCircleIcon } from '@phosphor-icons/react'

import { Icon } from '@/components/ui/icon'

import * as S from './navbar-menu.styled'
import { NavbarMenuItemProps } from './navbar-menu.types'

export const NavbarMenuItem = ({
  className,
  children,
  active = false,
  disabled = false,
  error = false,
  icon,
  mode = 'default',
  size = 'medium',
  onClick,
}: NavbarMenuItemProps) => {
  if (mode === 'tabs') {
    return (
      <S.TabButton
        className={className}
        type="button"
        $active={active}
        disabled={disabled}
        data-component-id="NavbarMenuItem"
        onClick={onClick}
      >
        {icon && <Icon icon={icon} size="3.2rem" />}
        {children}
      </S.TabButton>
    )
  }

  return (
    <S.NavButton
      className={className}
      type="button"
      $size={size}
      disabled={disabled}
      data-active={active}
      data-component-id="NavbarMenuItem"
      onClick={onClick}
    >
      {children}
      {error && <Icon icon={WarningCircleIcon} color="red500" />}
    </S.NavButton>
  )
}
